import {Col, Modal } from 'antd';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ReactComponent as RoundTickIcon} from '../../../../../../../assets/images/svg/i_round_tick.svg';
import { RootState } from '../../../../../../../store';
import { setSuccessModal } from '../../../../../../../store/actions/newAdmissionAction';
import { ApplicationDetailModel } from '../../../../../../../store/models/applicationDetailModel';
import './VerifyIdentityModal.less';

const VerificationSuccessModal = (): any => {
  const {
    newAdmission: {selectedOption, successModalVisible},
  }: any = useSelector((state: RootState): RootState => state);
  const appdetails = useSelector(
    (state: RootState): ApplicationDetailModel => state.applicationDetail,
  );
   const dispatch = useDispatch();

  const close = (): any => {
    dispatch(setSuccessModal(false));
  };
  return (
    <Modal
      visible={successModalVisible}
      footer={null}
      centered={true}
      onCancel ={close}
      maskClosable={true}
      >
      <Col className="fill-success icon-centre">
        <RoundTickIcon />
      </Col>
      <Col>
        <p className="text-success">
          {selectedOption} Verification sucessfully done for new claim creation at  {appdetails?.getProviderName()}
        </p>
      </Col>
    </Modal>);

};

export default VerificationSuccessModal;
